import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

interface CheckNumberFieldProps {
  // No props needed - component is self-contained
}

export const CheckNumberField: React.FC<CheckNumberFieldProps> = () => {
  const dispatch = useAppDispatch();
  const { currentRefund } = useAppSelector(state => state.refund);

  // Check number is editable when status is AP (Approved Pending)
  const isEditable = currentRefund?.status === 'AP';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isEditable) return;
    dispatch(updateCheckInfo({ checkNumber: event.target.value }));
  };

  return (
    <TextField
      label="Check Number"
      value={currentRefund?.checkInfo?.checkNumber || ''}
      onChange={handleChange}
      size="small"
      fullWidth
      required={isEditable}
      disabled={!isEditable}
      placeholder={isEditable ? "Enter check number" : "Not available"}
    />
  );
};

export default CheckNumberField;
